import { render } from "./AuthorityManage.vue?vue&type=template&id=2a3fc3b1"
import script from "./AuthorityManage.vue?vue&type=script&lang=js"
export * from "./AuthorityManage.vue?vue&type=script&lang=js"

import "./AuthorityManage.vue?vue&type=style&index=0&id=2a3fc3b1&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__